import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useOidc } from '@nohara-dxdev/react-oidc';
import { LoadingScreen } from '@nohara-dxdev/react-core';

import { paths } from '@/config/paths';

export const OidcLogoutRedirect = () => {
  const { isLoading, isAuthenticated, logout, config } = useOidc();
  const navigate = useNavigate();
  const triggered = useRef(false);

  useEffect(() => {
    if (isLoading || triggered.current) return;
    triggered.current = true;

    if (isAuthenticated) {
      logout()
        .then(() => {
          if (config) {
            const url = new URL(`https://${config.oauthEndpoint}/logout`);
            url.searchParams.set('client_id', config.userPoolWebClientId);
            url.searchParams.set(
              'logout_uri',
              new URL(config.signOutPath, window.location.origin).toString()
            );
            window.location.replace(url.toString());
          } else {
            navigate(paths.auth.login.path, { replace: true });
          }
        })
        .catch(() => {
          navigate(paths.auth.login.path, { replace: true });
        });
    } else {
      navigate(paths.auth.login.path, { replace: true });
    }
  }, [isLoading, isAuthenticated, logout, config, navigate]);

  return <LoadingScreen />;
};
